export default __webpack_public_path__ + "static/media/upload.d6ab57ca.svg";